import { MeasureParams, PivotFunction, StaticFeatureEnum, StyleVO } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_COMMAND_STATE, WIZ_EVENT_TYPE,  
  CONFIRMATION_MODE, CONFIRMATION_RESULT } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  WizBasePopUp,
  WizButton,
  WizPopUp,
  WizRoot,
  WizTextarea,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizVgroup,
  WizLabel,
  WizDropdown,
  WizCheckbox,
  WizNumericInput,
  WizDatasource,
  WizIcon,
  WizDateField,
  WizHgroup,
  WizTranslationBasic,
  WizTextInput,
  WizEventManager, WizEvent, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { FakeVO } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { FIELD_KIND, FormatVO, MeasureVO, WizConstants } from '@wizeoo/akm-compute-lib';
import { TranslatableLabelVO } from '@wizeoo/akm-common-lib';
import { FormulaEditorPop } from '@wizeoo/akm-common-lib';

/**
 * TODO gestion d'une fenêtre spécifique pour gérer les constantes et les weightGrids
 * renderer du pannel de droite de la vue de paramétrage des languages
 */
@Component({
  selector: 'measure-right-pop',
  templateUrl: './measure-right-pop.html', // TODO laisser le scrolling sur la droite / mettre dans le plan en 3ème div
})
export class MeasureRightPop extends WizBasePopUp {
  /**
   * Constructeur
   * @param elementRef elementRef pour pose d'écouteurs
   */
  constructor(public elementRef: ElementRef) {
    super();
  }

  public static requestWidth: string = '650px'; // pour override de prise de taille sur construction. Sera accessible depuis la factory

  @ViewChild('tiLabel', { read: WizLabel }) tiLabel: WizLabel; // libellé
  
  @ViewChild('trsLabel', { read: WizTranslationBasic }) trsLabel: WizTranslationBasic; // libellé traduit
  @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic;
  
  
  @ViewChild('ddDataKind', { read: WizDropdown }) ddDataKind: WizDropdown;
  @ViewChild('taSettings', { read: WizTextarea }) taSettings: WizTextarea;

  // gestion des numériques
  @ViewChild('formatNumberGP', { read: WizVgroup }) formatNumberGP: WizVgroup;
  @ViewChild('cbNegative', { read: WizCheckbox }) cbNegative: WizCheckbox;
  @ViewChild('ddFunc', { read: WizDropdown }) ddFunc: WizDropdown; // drop de choix de la fonction d'aggrégat
  @ViewChild('niNbDecimal', { read: WizNumericInput }) niNbDecimal: WizNumericInput;
  @ViewChild('niMinValue', { read: WizNumericInput }) niMinValue: WizNumericInput;
  @ViewChild('niMaxValue', { read: WizNumericInput }) niMaxValue: WizNumericInput;

  // gestion des textes
  @ViewChild('formatTextGP', { read: WizHgroup }) formatTextGP: WizHgroup;
  @ViewChild('niTextMinValue', { read: WizNumericInput }) niTextMinValue: WizNumericInput;
  @ViewChild('niTextMaxValue', { read: WizNumericInput }) niTextMaxValue: WizNumericInput;
  @ViewChild('tiRegex', { read: WizTextInput }) tiRegex: WizTextInput;
  @ViewChild('cbUpper', { read: WizCheckbox }) cbUpper: WizCheckbox; // forcer les majuscules

  // gestion des dates
  @ViewChild('formatDateGP', { read: WizHgroup }) formatDateGP: WizHgroup;
  @ViewChild('daMinValue', { read: WizDateField }) public daMinValue: WizDateField;
  @ViewChild('daMaxValue', { read: WizDateField }) public daMaxValue: WizDateField;

  // fonction de contrôle sur num / date
  @ViewChild('valueControlGP', { read: WizVgroup }) valueControlGP: WizVgroup;
  @ViewChild('tavalueControl', { read: WizTextarea }) tavalueControl: WizTextarea;
  @ViewChild('fxValueControl', { read: WizIcon }) fxValueControl: WizIcon;
  @ViewChild('trsValueControlMsg', { read: WizTranslationBasic }) trsValueControlMsg: WizTranslationBasic; // msg erreur sur badValue

  // lien crossDomain
  @ViewChild('taCrossRef', { read: WizTextarea }) taCrossRef: WizTextarea;


  // fonction de restriction d'édition
  @ViewChild('editRestrictGP', { read: WizVgroup }) editRestrictGP: WizVgroup;
  @ViewChild('taEditRestrict', { read: WizTextarea }) taEditRestrict: WizTextarea;
  @ViewChild('fxEditRestrict', { read: WizIcon }) fxEditRestrict: WizIcon;
  @ViewChild('trsRestrictMsg', { read: WizTranslationBasic }) trsRestrictMsg: WizTranslationBasic; // msg erreur sur restrict

  // fonction de valeur par défaut et trigger
  @ViewChild('editTriggerGP', { read: WizVgroup }) editTriggerGP: WizVgroup;
  @ViewChild('taEditDefault', { read: WizTextarea }) taEditDefault: WizTextarea;
  @ViewChild('fxEditDefault', { read: WizIcon }) fxEditDefault: WizIcon;
  @ViewChild('taEditTrigger', { read: WizTextarea }) taEditTrigger: WizTextarea;
  @ViewChild('fxEditTrigger', { read: WizIcon }) fxEditTrigger: WizIcon;

  // gestion des constantes
  @ViewChild('formatConstantGP', { read: WizVgroup }) formatConstantGP: WizVgroup;
  @ViewChild('tiConstantValue', { read: WizTextInput }) tiConstantValue: WizTextInput;
  // @ViewChild('niConstantNbDecimal', { read: WizNumericInput }) niConstantNbDecimal: WizNumericInput;
  // @ViewChild('niConstantValue', { read: WizNumericInput }) niConstantValue: WizNumericInput;

  // format et style
  @ViewChild('styleFormatGP', { read: WizVgroup }) styleFormatGP: WizVgroup;
  @ViewChild('ddFormat', { read: WizDropdown }) ddFormat: WizDropdown;
  @ViewChild('ddStyle', { read: WizDropdown }) ddStyle: WizDropdown;

  // gestion formule I
  @ViewChild('formulaIGP', { read: WizVgroup }) formulaIGP: WizVgroup;
  @ViewChild('cbIVisible', { read: WizCheckbox }) cbIVisible: WizCheckbox;
  @ViewChild('taI', { read: WizTextarea }) taI: WizTextarea;
  @ViewChild('cbEditable', { read: WizCheckbox }) cbEditable: WizCheckbox;
  @ViewChild('fxI', { read: WizIcon }) fxI: WizIcon;

  // gestion autres formules
  @ViewChild('formulaOtherGP', { read: WizVgroup }) formulaOtherGP: WizVgroup;
  @ViewChild('taF', { read: WizTextarea }) taF: WizTextarea;
  @ViewChild('taS', { read: WizTextarea }) taS: WizTextarea;
  @ViewChild('taT', { read: WizTextarea }) taT: WizTextarea;
  @ViewChild('cbSVisible', { read: WizCheckbox }) cbSVisible: WizCheckbox;
  @ViewChild('cbFVisible', { read: WizCheckbox }) cbFVisible: WizCheckbox;
  @ViewChild('cbTVisible', { read: WizCheckbox }) cbTVisible: WizCheckbox;
  @ViewChild('fxS', { read: WizIcon }) fxS: WizIcon;
  @ViewChild('fxF', { read: WizIcon }) fxF: WizIcon;
  @ViewChild('fxT', { read: WizIcon }) fxT: WizIcon;

  /** Zone de detail (pour updateEvent) */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;
  /** référence du validateur des champs de saisie */
  @ViewChild('vgDetailZone', { read: WizValidationContainerDirective })
  private vgDetailZoneValidator: WizValidationContainerDirective;
  /** Composant de saisie du libellé traductible */
  // @ViewChild('tiLabelTrs', { read: WizTranslationBasic, static: false }) tiLabelTrs: WizTranslationBasic;

  /** Bouton de sauvegarde */
  @ViewChild('btOk', { read: WizButton }) btOk: WizButton;
  /** Bouton d'annulation de saisie */
  @ViewChild('btCancel', { read: WizButton }) btCancel: WizButton;
  @ViewChild('btDelete', { read: WizIcon }) btDelete: WizIcon;

  /** la DS des fonctions d'aggrégat */
  public functionDS: WizDatasource<PivotFunction> = new WizDatasource<PivotFunction>(
    Array.from(Model.getInstance().aggregateEngine.functionMap().values())
  )
    .setFilter(this.aggregateDataKindFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .build();

  /** DS de la drop des formats */
  public formatDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>(Model.getInstance().formatEngine.getFormatList())
    .setFilter(this.dataKindFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  public styleDS: WizDatasource<StyleVO> = new WizDatasource<StyleVO>(Model.getInstance().styleList)
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop de types de données */
  public datatypeDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().datatypeList)
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .build();

  private clone: MeasureVO = null; // instance de travail

  public labelVO: TranslatableLabelVO;
  public descVO: TranslatableLabelVO;
  public editRestrictVO: TranslatableLabelVO;
  public controlVO: TranslatableLabelVO;

  /**
   * affichage conditionnel des zone defaultValue et triggerValue
   */
  public get isEditable(): boolean {
    return !!this.clone?.editable;
  }

  /**
   * affichage du contenu si présence d'une mesure
   */
  public get hasMeasure(): boolean {
    return !!this.datas;
  }

  public show(): void {
    super.show();

    this.ddDataKind.wizDataProvider = this.datatypeDS; // alimentation de la drop des types de données
    this.ddFormat.wizDataProvider = this.formatDS; // alimentation de la drop des formats
    this.ddStyle.wizDataProvider = this.styleDS; // alimentation de la drop des styles
    this.ddFunc.wizDataProvider = this.functionDS; // alimentation de la drop des méthodes d'aggrégat

    this.updateData();

    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
  }

  /**
   * méthode appelée à la fermeture de la pop
   */
  public onHide(): void {
    super.onHide();
  }

  /** alimentation de la mesure */
  private updateData(): void {
    const meas: MeasureVO = Model.getInstance().currentMeasure;
    this.datas = meas;
    if (!!this.datas) {
      this.clone = Model.getInstance().measureEngine.clone(this.datas);

      this.labelVO = Model.getInstance().measureEngine.getMeasureLabelVO(this.clone);
      this.descVO =  Model.getInstance().measureEngine.getMeasureDescriptionVO(this.clone);
      this.editRestrictVO = Model.getInstance().measureEngine.getMeasureEditRestrictMessageVO(this.clone);
      this.controlVO = Model.getInstance().measureEngine.getMeasureValueControlMessageVO(this.clone)

      // construction du libellé, code & step
      let lbl: string = Model.getInstance().measureEngine.getMeasureLabel(this.clone.source);
      if (!!this.clone.stepLevel) {
        lbl += '  ' + WizTranslationManager.getInstance().translateKey('$.measure.step.level.$', [this.clone.stepLevel.toString()]);
      }
      this.tiLabel.wizLabel = lbl;
      this.trsLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.labelVO);
      this.trsDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(this.descVO);
      this.trsRestrictMsg.translationData = Model.getInstance().localeEngine.buildTranslationData(this.editRestrictVO);
      this.trsValueControlMsg.translationData = Model.getInstance().localeEngine.buildTranslationData(this.controlVO);

      let datakind: FakeVO = null; // le type de données en forme "objet"
      if (this.clone.datakind) {
        datakind = this.datatypeDS.getItemByKey(this.clone.datakind);
      } else { // patch, pas de création au niveau 0... reprise du 1er trouvé
        // console.log('noKind', this.clone);
        const alls: MeasureVO[] = Model.getInstance().measureEngine.getMeasureList();
        alls.forEach((m: MeasureVO) => {
          if(m.code === this.clone.code && !!m.datakind && m.vision === this.clone.vision) {
            this.clone.datakind = m.datakind;
            this.clone.formatCode = m.formatCode;
            this.clone.styleCode = m.styleCode;
            this.clone.allowNegative = m.allowNegative;
            this.clone.nbDecimal = m.nbDecimal;
            this.clone.minValue = m.minValue;
            this.clone.maxValue = m.maxValue;
            this.clone.settings = m.settings;
            this.clone.defaultAgg = m.defaultAgg;
            datakind = this.datatypeDS.getItemByKey(this.clone.datakind);
            return;
          }
        });
      }

      this.datatypeDS.select([datakind]);
      // génération du settings en mode string
      if(this.clone.settings) {
        this.clone.settingsStr = JSON.stringify(this.clone.settings);
      }
      
      this.taSettings.wizValue = this.clone.settingsStr;

      this.formatDS.refresh(); // réactualiser la liste des formats
      let format: FormatVO = null; // le format de données
      if (this.clone.formatCode) {
        const formatSplit: string[] = this.clone.formatCode.split(ViewData.KEY_SEPARATOR);
        format = Model.getInstance().formatEngine.getFormat(formatSplit[0], formatSplit[1]);
      }
      this.formatDS.select([format]);

      let style: StyleVO = null; // le format de données
      if (this.clone.styleCode) {
        const styleSplit: string[] = this.clone.styleCode.split(ViewData.KEY_SEPARATOR);
        style = Model.getInstance().styleEngine.getStyle(styleSplit[0], styleSplit[1]);
      }
      this.styleDS.select([style]);

      this.updateDataLimits(); // cohérence des zones de restriction de saisie

      this.tavalueControl.wizValue = this.clone.valueControl;
      this.taEditRestrict.wizValue = this.clone.editRestrict;
      this.taEditDefault.wizValue = this.clone.defaultValue;
      this.taEditTrigger.wizValue = this.clone.triggerValue;
      this.cbEditable.wizChecked = this.clone.editable;

      if(this.clone.linkedRef) {
        this.clone.linkedRefStr = JSON.stringify(this.clone.linkedRef);
      }
      this.taCrossRef.wizValue = this.clone.linkedRefStr;

      const mode: string = this.clone.mode ? this.clone.mode : '';
      this.cbIVisible.wizChecked = mode.indexOf(WizConstants.MEASURE_MODE_INTERACT) > -1;
      this.cbSVisible.wizChecked = mode.indexOf(WizConstants.MEASURE_MODE_SUBMIT) > -1;
      this.cbFVisible.wizChecked = mode.indexOf(WizConstants.MEASURE_MODE_FROM) > -1;
      this.cbTVisible.wizChecked = mode.indexOf(WizConstants.MEASURE_MODE_TO) > -1;

      this.taF.wizValue = this.clone.formulaF;
      this.taI.wizValue = this.clone.formulaI;
      this.taS.wizValue = this.clone.formulaS;
      this.taT.wizValue = this.clone.formulaT;
    } else {
      // this.hide(); // fermeture si pas de mesure
    }

    setTimeout(() => {
      ViewData.wizUpdateModel = false;
      this.manageComponents();
    }, 0);
  }

  /** alimentation des zones de restrictions de format, selon le type de donnée */
  private updateDataLimits(): void {
    const dataType: string = this.clone.datakind; // le type
    
    // this.cbPpc.wizChecked = this.clone.pivotPostCompute;
    let func: string = Model.getInstance().dataEngine.pkdDefaultAggregateFunction(this.clone.datakind);
    if (this.clone.defaultAgg) {
      func = this.clone.defaultAgg;
    }
    this.functionDS.refresh();
    this.functionDS.select([this.functionDS.getItemByKey(func)]);
    

    if (dataType === FIELD_KIND.INT || dataType === FIELD_KIND.NUMBER) {
      // integer & decimal
      this.cbNegative.wizChecked = this.clone.allowNegative;
      this.niNbDecimal.wizNumber = this.clone.nbDecimal;
      this.niMinValue.wizNumber = this.clone.minValue !== null ? Number(this.clone.minValue) : null;
      this.niMaxValue.wizNumber = this.clone.maxValue !== null ? Number(this.clone.maxValue) : null;
    } else {
      this.cbNegative.wizChecked = null;
      this.niNbDecimal.wizNumber = null;
      this.niMinValue.wizNumber = null;
      this.niMaxValue.wizNumber = null;
    }

    if (dataType === FIELD_KIND.STRING || dataType === FIELD_KIND.COMMENT) {
      // textes
      this.niTextMinValue.wizNumber = this.clone.minValue !== null ? Number(this.clone.minValue) : null;
      this.niTextMaxValue.wizNumber = this.clone.maxValue !== null ? Number(this.clone.maxValue) : null;
      this.tiRegex.wizValue = this.clone.editRegex;
      this.cbUpper.wizChecked = this.clone.upper;
    } else {
      this.niTextMinValue.wizNumber = null;
      this.niTextMaxValue.wizNumber = null;
      this.tiRegex.wizValue = null;
      this.cbUpper.wizChecked = false;
    }


    if (dataType === FIELD_KIND.DATE) {
      // date
      this.daMinValue.wizNumberValue = this.clone.minValue !== null ? Number(this.clone.minValue) : null;
      this.daMaxValue.wizNumberValue = this.clone.maxValue !== null ? Number(this.clone.maxValue) : null;
    } else {
      this.daMinValue.wizNumberValue = null;
      this.daMaxValue.wizNumberValue = null;
      this.daMinValue.wizMaxDate = null;
      this.daMaxValue.wizMinDate = null;
    }

    // alimentation zone constante
    if (dataType === FIELD_KIND.CONSTANT) {
      // this.niConstantNbDecimal.wizNumber = this.clone.nbDecimal;
      this.tiConstantValue.wizValue = this.clone.formulaI ? this.clone.formulaI : null;
    } else {
      // this.niConstantNbDecimal.wizNumber = null;
      this.tiConstantValue.wizValue = null;
    }
  }

  /** contrôle de la cohérence de la configuration, et correction éventuelle */
  private checkIntegrity(): void {
    const dataType: string = this.clone.datakind; // le type
    if (dataType === FIELD_KIND.INT) {
      this.clone.nbDecimal = 0;
      this.niNbDecimal.wizNumber = 0;
    }
    if (!this.clone.allowNegative) {
      // négatif non autorisé, et minValue < 0
      if (!!this.clone.minValue && Number(this.clone.minValue) < 0) {
        this.clone.minValue = '0';
        this.niMinValue.wizNumber = 0;
      }
    }

    if (!this.clone.allowNegative) {
      // négatif non autorisé, et maxValue < 0
      if (!!this.clone.maxValue && Number(this.clone.maxValue) < 0) {
        this.clone.maxValue = null;
        this.niMaxValue.wizNumber = null;
      }
    }

    if (!!this.clone.minValue && !!this.clone.maxValue) {
      // cohérence minMax
      if (Number(this.clone.maxValue) < Number(this.clone.minValue)) {
        this.clone.maxValue = null;
        if (dataType === FIELD_KIND.INT || dataType === FIELD_KIND.NUMBER) {
          this.niMaxValue.wizNumber = null;
        } else if (dataType === FIELD_KIND.DATE) {
          this.daMaxValue.wizNumberValue = null;
        }
      }
    }
  }

  /** gestion de l'affichage des composants, selon le type */
  private manageComponents(): void {
    if (ViewData.wizUpdateModel) {
      this.btOk.wizDisabled = false; // bt validation, si modif
      this.btCancel.wizDisabled = false; // bt cancel, pareil
    } else {
      this.btOk.wizDisabled = true; // bt validation, si modif
      this.btCancel.wizDisabled = true; // bt cancel, pareil
    }

    const hasDataType: boolean = !!this.clone?.datakind; // j'ai un type
    const isContant: boolean = this.clone?.datakind === FIELD_KIND.CONSTANT; // c'est une constante
    const isDate: boolean = this.clone?.datakind === FIELD_KIND.DATE; // c'est une date
    const isText: boolean = this.clone && (this.clone.datakind === FIELD_KIND.STRING || this.clone.datakind === FIELD_KIND.COMMENT); // c'est une date
    const numConf: boolean =
      !!this.clone?.datakind &&
      (this.clone.datakind === FIELD_KIND.INT || this.clone.datakind === FIELD_KIND.NUMBER); // c'est un nombre
    const intConf: boolean = this.clone && this.clone.datakind && this.clone.datakind === FIELD_KIND.INT; // juste un entier
    const allowNegative: boolean = this.clone && this.clone.allowNegative; // négatif autorisé

    const iEnabled: boolean = this.clone?.mode?.indexOf(WizConstants.MEASURE_MODE_INTERACT) > -1;
    const sEnabled: boolean = this.clone?.mode?.indexOf(WizConstants.MEASURE_MODE_SUBMIT) > -1;
    const fEnabled: boolean = this.clone?.mode?.indexOf(WizConstants.MEASURE_MODE_FROM) > -1;
    const tEnabled: boolean = this.clone?.mode?.indexOf(WizConstants.MEASURE_MODE_TO) > -1;
    const iEditable: boolean = this.clone?.editable;

    if (numConf) {
      // un format numérique
      this.niMinValue.nbDecimal = this.clone ? this.clone.nbDecimal : 0; // décimales sur min
      this.niMaxValue.nbDecimal = this.clone ? this.clone.nbDecimal : 0; // décimales sur max
      this.niMinValue.allowNegative = allowNegative;
      this.niMaxValue.allowNegative = allowNegative;
      this.niMinValue.wizMinNumber = !allowNegative ? 0 : null;
      this.niMaxValue.wizMinNumber = this.niMinValue.wizNumber; // le min du Max, c'est la valeur du min
      this.niMinValue.wizMaxNumber = this.niMaxValue.wizNumber; // le max du Min, c'est la valeur du max
    } else if (isDate) {
      // contrôle de cohérence date
      this.daMaxValue.wizMinDate = this.daMinValue.wizDateValue; // le min du Max, c'est la valeur du min
      this.daMinValue.wizMaxDate = this.daMaxValue.wizDateValue; // le max du Min, c'est la valeur du max
    } else if (isContant) {
      // contrôle de cohérence constante
      // this.niConstantValue.nbDecimal = this.clone ? this.clone.nbDecimal : 0; // décimales sur min
    } else if (isText) {
      // contrôle de cohérence constante
      this.niTextMinValue.nbDecimal = 0; // décimales sur min
      this.niTextMaxValue.nbDecimal = 0; // décimales sur max
      this.niTextMinValue.allowNegative = false;
      this.niTextMaxValue.allowNegative = false;
      this.niTextMinValue.wizMinNumber = 0 ;
      this.niTextMaxValue.wizMinNumber = this.niTextMinValue.wizNumber; // le min du Max, c'est la valeur du min
      this.niTextMinValue.wizMaxNumber = this.niTextMaxValue.wizNumber; // le max du Min, c'est la valeur du max

    } else {
      this.cbNegative.wizChecked = false;
      this.niNbDecimal.wizNumber = null;
      this.niMinValue.wizNumber = null;
      this.niMaxValue.wizNumber = null;
      if (this.clone) {
        this.clone.allowNegative = false;
        this.clone.nbDecimal = null;
        this.clone.minValue = null;
        this.clone.maxValue = null;
      }
    }

    if (iEditable) {
      // post-traitement formulaI
      this.taI.wizValue = null;
      this.clone.formulaI = null;
    }

    this.taSettings.visible = this.clone?.datakind === FIELD_KIND.LIST || 
    this.clone?.datakind === FIELD_KIND.FILTER || 
    this.clone?.datakind === FIELD_KIND.CROSS_FILTER || 
    this.clone?.datakind === FIELD_KIND.THRESHOLD || 
    this.clone?.datakind === FIELD_KIND.WORKFLOW;
    this.taSettings.wizDisabled = this.cantUpdate;

    this.valueControlGP.visible = hasDataType; // pour gestion par widget iEditable &&  hasDataType && (numConf || isDate); // zone fonction de contrôle, uniquement num & dates
    const mode: string = this.clone?.mode ? this.clone.mode : '';
    this.editRestrictGP.visible = mode.indexOf(WizConstants.MEASURE_MODE_INTERACT) > -1; // iEditable; // zone fonction de restriction de saisie


    this.ddFunc.wizDisabled = this.cantUpdate || !hasDataType; // drop aggregat
    this.ddFormat.wizDisabled = this.cantUpdate || !hasDataType; // drop format
    this.ddStyle.wizDisabled = this.cantUpdate || !hasDataType; // drop style

    this.formatNumberGP.visible = hasDataType && numConf; // zone de configuration des number (décimales, min, max, négatif)
    this.formatConstantGP.visible = hasDataType && isContant; // zone de conf des constantes (decimales & valeur)
    this.formatDateGP.visible = hasDataType && isDate; // zone de conf des dates (min & max)

    this.formatTextGP.visible = hasDataType && isText; // zone de conf des textes (min & max)

    this.styleFormatGP.visible = hasDataType && !isContant; // choix du style
    this.formulaIGP.visible = hasDataType && !isContant; // zone de conf mode I
    this.formulaOtherGP.visible = hasDataType && !isContant; // les autres modes

    // limites date ou num
    this.niMinValue.visible = numConf; // conf numérique
    this.niMaxValue.visible = numConf; // conf numérique

    // this.cbNegative.wizDisabled = !numConf; // conf numérique
    this.niNbDecimal.wizDisabled = this.cantUpdate || !numConf || intConf; // décimale, uniquement... décimal
    // this.niMinValue.wizDisabled = !numConf; // conf numérique
    // this.niMaxValue.wizDisabled = !numConf; // conf numérique

    this.cbIVisible.wizDisabled = this.cantUpdate || !hasDataType; // zone I
    this.cbEditable.wizDisabled = this.cantUpdate || !hasDataType || !iEnabled; // d'abord visible sur I pour être éditable

    this.cbSVisible.wizDisabled = this.cantUpdate || !hasDataType;
    this.cbFVisible.wizDisabled = this.cantUpdate || !hasDataType;
    this.cbTVisible.wizDisabled = this.cantUpdate || !hasDataType;

    this.taI.wizDisabled = this.cantUpdate || !hasDataType || !iEnabled || iEditable;
    this.taS.wizDisabled = this.cantUpdate || !hasDataType || !sEnabled;
    this.taF.wizDisabled = this.cantUpdate || !hasDataType || !fEnabled;
    this.taT.wizDisabled = this.cantUpdate || !hasDataType || !tEnabled;

    this.fxI.wizDisabled = this.cantUpdate || !hasDataType || !iEnabled || iEditable;
    this.fxS.wizDisabled = this.cantUpdate || !hasDataType || !sEnabled;
    this.fxF.wizDisabled = this.cantUpdate || !hasDataType || !fEnabled;
    this.fxT.wizDisabled = this.cantUpdate || !hasDataType || !tEnabled;

    this.btDelete.wizDisabled = !this.clone || !this.clone.stepLevel || this.clone.stepLevel === 0;

    // TODO filterFunc sur les formats

    if (iEditable) {
      // pas de saisie de formule I si mesure éditable
      this.taI.wizDisabled = true;
    }

    // post-traitement, pas de changement de type au-delà du niveau 0
    // console.log('lock dd', this.clone.code, this.clone.stepLevel, this.clone.allMySteps.length);
    this.ddDataKind.wizDisabled = this.cantUpdate || !this.clone || this.clone.stepLevel > 0 || Model.getInstance().measureEngine.getSimilarMeasures(this.clone).length > 1;
  }

  public cancel(): void {
    this.updateData();
  }

  private reset(): void {
    this.tiLabel.wizLabel = null;

    this.taF.wizValue = null;
    this.taI.wizValue = null;
    this.taS.wizValue = null;
    this.taT.wizValue = null;
  }

  /** demande de suppression de la mesure */
  public doDelete(): void {
    // console.log('doDelete', this.datas);
    this.confirmRemove(this.clone);
  }

  /**
   * Validateur d'unicité du code
   */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      if (!!this.clone) {
        if (Model.getInstance().measureEngine.duplicatedCode(this.clone)) {
          const temp: WizValidationError = { wizError: '$.measure.error.code.unique.$', wizErrorParams: [] };
          return [temp];
        }
      }
      return null;
    };
  }

  /**
   * Validateur de la formule F
   */
  public formulaFValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      const res: [boolean, string] = Model.getInstance().measureEngine.isValidFormula(Model.getInstance().measureEngine.currentFEI, this.clone, WizConstants.MEASURE_MODE_FROM);
      if (res[0]) {
        const temp: WizValidationError = { wizError: '$.measure.error.formulaF.$', wizErrorParams: [res[1]] };
        return [temp];
      }
      return null;
    };
  }

  /**
   * Validateur de la formule I
   */
  public formulaIValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      const res: [boolean, string] = Model.getInstance().measureEngine.isValidFormula(Model.getInstance().measureEngine.currentFEI, this.clone, WizConstants.MEASURE_MODE_INTERACT);
      if (res[0]) {
        const temp: WizValidationError = { wizError: '$.measure.error.formulaI.$', wizErrorParams: [res[1]] };
        return [temp];
      }
      return null;
    };
  }

  /**
   * Validateur de la formule S
   */
  public formulaSValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      const res: [boolean, string] = Model.getInstance().measureEngine.isValidFormula(Model.getInstance().measureEngine.currentFEI, this.clone, WizConstants.MEASURE_MODE_SUBMIT);
      if (res[0]) {
        const temp: WizValidationError = { wizError: '$.measure.error.formulaS.$', wizErrorParams: [res[1]] };
        return [temp];
      }
      return null;
    };
  }

  /**
   * Validateur de la formule T
   */
  public formulaTValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      const res: [boolean, string] = Model.getInstance().measureEngine.isValidFormula(Model.getInstance().measureEngine.currentFEI, this.clone, WizConstants.MEASURE_MODE_TO);
      if (res[0]) {
        const temp: WizValidationError = { wizError: '$.measure.error.formulaT.$', wizErrorParams: [res[1]] };
        return [temp];
      }
      return null;
    };
  }

  /**
   * Validateur de la formule de contrôle TODO
   */
  public formulaCValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      const res: [boolean, string] = Model.getInstance().measureEngine.isValidFormula(Model.getInstance().measureEngine.currentFEI, this.clone, WizConstants.MEASURE_MODE_TO);
      if (res[0]) {
        const temp: WizValidationError = { wizError: '$.measure.error.formulaC.$', wizErrorParams: [res[1]] };
        return [temp];
      }
      return null;
    };
  }

  /**
   * Validateur de la formule de restriction de saisie TODO
   */
   public formulaRValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      const res: [boolean, string] = Model.getInstance().measureEngine.isValidFormula(Model.getInstance().measureEngine.currentFEI, this.clone, WizConstants.MEASURE_MODE_TO);
      if (res[0]) {
        const temp: WizValidationError = { wizError: '$.measure.error.formulaR.$', wizErrorParams: [res[1]] };
        return [temp];
      }
      return null;
    };
  }

  /**
   * Validateur de la formule valeur par défaut TODO
   */
  public formulaDValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      const res: [boolean, string] = Model.getInstance().measureEngine.isValidFormula(Model.getInstance().measureEngine.currentFEI, this.clone, WizConstants.MEASURE_MODE_TO);
      if (res[0]) {
        const temp: WizValidationError = { wizError: '$.measure.error.formulaD.$', wizErrorParams: [res[1]] };
        return [temp];
      }
      return null;
    };
  }

  /**
   * Validateur de la formule trigger TODO
   */
  public formulaGValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      const res: [boolean, string] = Model.getInstance().measureEngine.isValidFormula(Model.getInstance().measureEngine.currentFEI, this.clone, WizConstants.MEASURE_MODE_TO);
      if (res[0]) {
        const temp: WizValidationError = { wizError: '$.measure.error.formulaG.$', wizErrorParams: [res[1]] };
        return [temp];
      }
      return null;
    };
  }


  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // console.log('updateModel', e.value);
    switch (e.component) {
      case this.trsLabel:
        this.labelVO.updateTranslationEntry(e.value);
        break;
      case this.trsDesc:
        this.descVO.updateTranslationEntry(e.value);
        break;
      case this.trsRestrictMsg:
        this.editRestrictVO.updateTranslationEntry(e.value);
        break;
      case this.trsValueControlMsg:
          this.controlVO.updateTranslationEntry(e.value);
          break;     
      case this.ddDataKind:
        this.clone.datakind = this.datatypeDS.selectedItem.code;
        this.clone.maxValue = null;
        this.clone.minValue = null;
        
        // contrôles primitifs
        if (this.clone.datakind && this.clone.datakind === FIELD_KIND.CONSTANT) {
          this.clone.mode = WizConstants.MEASURE_MODE_CONSTANT;
          this.clone.editable = false;
        }
        if (this.clone.datakind && this.clone.datakind === FIELD_KIND.INT) {
          this.clone.nbDecimal = 0;
        }
        this.formatDS.clearSelection();
        this.formatDS.refresh(); // les formats sont conditionnés par le type
        this.functionDS.clearSelection();
        this.functionDS.refresh(); // les aggrégats aussi
        break;
      case this.cbNegative:
        this.clone.allowNegative = this.cbNegative.wizChecked;
        break;
      case this.niNbDecimal:
        this.clone.nbDecimal = this.niNbDecimal.wizNumber;
        break;
      case this.niMinValue:
        this.clone.minValue = this.niMinValue.wizNumber !== null ? this.niMinValue.wizNumber.toString() : null;
        break;
      case this.niMaxValue:
        this.clone.maxValue = this.niMaxValue.wizNumber !== null ? this.niMaxValue.wizNumber.toString() : null;
        break;
      case this.niTextMinValue:
          this.clone.minValue = this.niTextMinValue.wizNumber !== null ? this.niTextMinValue.wizNumber.toString() : null;
          break;
      case this.niTextMaxValue:
          this.clone.maxValue = this.niTextMaxValue.wizNumber !== null ? this.niTextMaxValue.wizNumber.toString() : null;
          break;
        case this.tiRegex:
          this.clone.editRegex = this.tiRegex.wizValue;
          break;
      case this.cbUpper:
        this.clone.upper = this.cbUpper.wizChecked;
        break;
      case this.daMinValue:
        this.clone.minValue =
          !!this.daMinValue.wizNumberValue ? this.daMinValue.wizNumberValue.toString() : null;
        break;
      case this.daMaxValue:
        this.clone.maxValue =
          !!this.daMaxValue.wizNumberValue ?  this.daMaxValue.wizNumberValue.toString() : null;
        break;
      case this.tavalueControl:
        this.clone.valueControl = this.tavalueControl.wizValue;
        break;
      case this.taEditRestrict:
        this.clone.editRestrict = this.taEditRestrict.wizValue;
        break;  
      case this.taEditDefault:
        this.clone.defaultValue = this.taEditDefault.wizValue;
        break; 
      case this.taEditTrigger:
        this.clone.triggerValue = this.taEditTrigger.wizValue;
        break; 
      case this.ddFormat:
        const format: FormatVO = this.formatDS.selectedItem;
        const formatCode: string = format ? format.businessUnitCode + ViewData.KEY_SEPARATOR + format.code : null;
        this.clone.formatCode = formatCode;
        break;
      case this.ddStyle:
        const style: StyleVO = this.styleDS.selectedItem;
        const styleCode: string = style ? style.visionCode + ViewData.KEY_SEPARATOR + style.code : null;
        this.clone.styleCode = styleCode;
        break;
      case this.cbEditable:
        this.clone.editable = this.cbEditable.wizChecked;
        break;
      case this.taF:
        this.clone.formulaF = e.value;
        break;
      case this.taI:
        this.clone.formulaI = e.value;
        break;
      case this.taS:
        this.clone.formulaS = e.value;
        break;
      case this.taT:
        this.clone.formulaT = e.value;
        break;
      case this.cbIVisible:
      case this.cbSVisible:
      case this.cbFVisible:
      case this.cbTVisible:
        let mode: string = '';
        if (this.cbFVisible.wizChecked) {
          mode += WizConstants.MEASURE_MODE_FROM;
        }
        if (this.cbIVisible.wizChecked) {
          mode += WizConstants.MEASURE_MODE_INTERACT;
        }
        if (this.cbSVisible.wizChecked) {
          mode += WizConstants.MEASURE_MODE_SUBMIT;
        }
        if (this.cbTVisible.wizChecked) {
          mode += WizConstants.MEASURE_MODE_TO;
        }
        this.clone.mode = mode;
        // console.log('mode', this.clone.mode);
        break;
      // gestion des constantes
      // case this.niConstantNbDecimal:
      //   this.clone.nbDecimal = this.niConstantNbDecimal.wizNumber;
      //   break;
      case this.tiConstantValue:
        this.clone.formulaI = this.tiConstantValue.wizValue; //  ? this.tiConstantValue.wizNumber.toString() : null;
        break;
      case this.taSettings:
        this.clone.settingsStr = this.taSettings.wizValue;
        break;
      case this.taCrossRef:
        this.clone.linkedRefStr = this.taCrossRef.wizValue;
        break;
      case this.ddFunc:
        this.clone.defaultAgg = this.functionDS.selectedItem?.code || null;
        break;

    }
    // console.log('fi', this.clone.formulaI);
    // on informe que le model a changé
    ViewData.wizUpdateModel = true;
    this.checkIntegrity(); // contrôle de cohérence
    this.manageComponents(); // gestion de l'affichage
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }

  /** Sauvegarde */
  public save(): void {
    // Vérification de la saisie
    const errors = this.vgDetailZoneValidator.check(true, true);
    if (errors && errors.length === 0) {
      // controle de cohérence des formules, pas de réf circulaire
      if (Model.getInstance().measureEngine.isValid(Model.getInstance().measureEngine.currentFEI, this.clone)) {
        
        // patch, éviter l'absence de visionID sur la mesure
        this.clone.vid = Model.getInstance().currentVision?.id;
        
        if (this.clone.stepLevel !== Model.getInstance().currentStepLevel) {
          // création d'un override
          this.clone.stepLevel = Model.getInstance().currentStepLevel;
          // perte des IDs
          this.clone.id = null;
          this.clone.version = 0;
        }

        // patch pour alimentation correcte des settings
        if(this.clone.settingsStr) {
          try {
            this.clone.settings = JSON.parse(this.clone.settingsStr);
          }
          catch(e: any) {

          } 
        } else {
          this.clone.settings = null;
        }

        // patch pour alimentation correcte des crossDomain
        if(this.clone.linkedRefStr) {
          try {
            this.clone.linkedRef= JSON.parse(this.clone.linkedRefStr);
          }
          catch(e: any) {
            console.log('e', e);
          } 
        } else {
          this.clone.linkedRef = null;
        }

        Model.getInstance().measureEngine.merge(this.clone, this.datas, this.mergeCallback.bind(this));
      } else {
        // la mesure n'est pas valide
      }
    }
  }

  /**
   * Retour de service merge
   * @param  bddPersist: MeasureVO
   * @param status le statut de retour du service
   * @return boolean: vrai si la comande est en succès
   */
  private mergeCallback(bddPersist: MeasureVO, status: string): boolean {
    let result = false; // Si la commande est en succès
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      result = true;
      // mise a jour du currentMeasure et du clone
      this.updateData();
      // fire un event pour refresh de la zone de dessin
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_RECOMPUTE, bddPersist));
    }
    return result;
  }

  /**
   * Demande de suppression d'une mesure
   * @param meas : Mesure à supprimé
   */
  private confirmRemove(meas: MeasureVO): void {
    if (Model.getInstance().measureEngine.isValidForRemove(meas)) {
      WizPopUp.confirm(
        '$.common.delete.title.$',
        '$.common.delete.detail.$',
        this.doRemove.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        meas
      ).show();
    } else {
      WizPopUp.toast('$.measure.toast.remove.unvalid.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Suppression de la mesure
   * @param result Objet de retour sur popUp de confirmation. Contient l'action choisie, et la data d'origine
   */
  private doRemove(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const meas: MeasureVO = result.data;
      if (meas) {
        if (meas.id > 0) {
          Model.getInstance().measureEngine.remove(meas, this.removeCallback.bind(this));
        } else {
          this.reset();
        }
      }
    }
  }

  /**
   * Callback de suppression
   * @param bddPersist, la mesure supprimée
   * @param status, Etat de la commande
   */
  private removeCallback(bddPersist: MeasureVO, status: string): void {
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      // fire un event pour refresh de la zone de dessin
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_DELETE, bddPersist));
      this.hide();
    }
  }

  /* #########################################
                    Editeur de formule
     ######################################### */

  /**
   * appel de la pop d'édition de formule depuis l'icone Fx
   * @param mode FIST
   */
  public showFormuleEditor(mode: string) {

    let params: MeasureParams = {
      measure: this.clone,
      mode,
      model: Model.getInstance(),
      callback: this.backFromPop.bind(this)
    }

    WizEventManager.dispatchEvent(
      WizRoot.root(),
      new AlkEvent(ALK_EVENT_TYPE.MEASURE_SHOW_FORMULA_EDITOR, 
        params)
    );
  }

  /**
   * retour d'édition de formule
   * @param backpop la popUp complète. La formule mise à jour se trouve dans currentFormula
   */
  private backFromPop(backpop: FormulaEditorPop): void {
    // console.log('back from functionPop', backpop);
    // TODO TODO mapper default et trigger
    this.clone['formula' + backpop.mode] = backpop.currentFormula;
    this['ta' + backpop.mode].wizValue = backpop.currentFormula;
    ViewData.wizUpdateModel = true;
    this.manageComponents();
  }

  public get cantUpdate(): boolean {
    // console.log('cantupdate', PermissionManager.instance.canUpdate(StaticFeatureEnum.MEASURE));
    return !Model.getInstance().permissionEngine.canUpdate(StaticFeatureEnum.MEASURE) || !this.clone;
  }

  /**
   * filterFunc de la liste des formats, selon le type de la données
   * @param e la fonction
   */
  public dataKindFilter(fm: FormatVO): boolean {
    if (!this.clone || !this.clone.datakind) {
      return false;
    }
    return fm.dataKind === this.clone.datakind;
  }

  /**
   * filterFunc de la liste de fonction d'aggrégat, selon le type de la données
   * @param e la fonction
   */
  public aggregateDataKindFilter(e: PivotFunction): boolean {
    let result: boolean = false;
    if (!this.clone?.datakind) {
      return false;
    }
    switch (this.clone.datakind) {
      case FIELD_KIND.INT:
      case FIELD_KIND.NUMBER:
      case FIELD_KIND.CONSTANT:
        result = e.forNum;
        break;
      case FIELD_KIND.DATE:
        // console.log('this data', this.datas);
        result = e.forDate;
        break;
      case FIELD_KIND.BOOLEAN:
        result = e.forBoolean;
        break;
      case FIELD_KIND.COLOR:
        result = e.forColor;
        break;
      case FIELD_KIND.STRING:
        result = e.forString;
        break;
      default:
        result = e.forString;
        break;
    }
    return result;
  }

}
